var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcasts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_377_6055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_377_6055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13.75V8.57812C6.6875 8.46354 6.53646 8.3151 6.42188 8.13281C6.30729 7.95052 6.25 7.73958 6.25 7.5C6.25 7.15625 6.3724 6.86198 6.61719 6.61719C6.86198 6.3724 7.15625 6.25 7.5 6.25C7.84375 6.25 8.13802 6.3724 8.38281 6.61719C8.6276 6.86198 8.75 7.15625 8.75 7.5C8.75 7.73958 8.69271 7.95313 8.57812 8.14063C8.46354 8.32813 8.3125 8.47396 8.125 8.57812V13.75H6.875ZM3.1875 12.0312C2.59375 11.4583 2.1224 10.7839 1.77344 10.0078C1.42448 9.23177 1.25 8.39583 1.25 7.5C1.25 6.63542 1.41406 5.82292 1.74219 5.0625C2.07031 4.30208 2.51562 3.64062 3.07812 3.07812C3.64062 2.51562 4.30208 2.07031 5.0625 1.74219C5.82292 1.41406 6.63542 1.25 7.5 1.25C8.36458 1.25 9.17708 1.41406 9.9375 1.74219C10.6979 2.07031 11.3594 2.51562 11.9219 3.07812C12.4844 3.64062 12.9297 4.30208 13.2578 5.0625C13.5859 5.82292 13.75 6.63542 13.75 7.5C13.75 8.39583 13.5755 9.23438 13.2266 10.0156C12.8776 10.7969 12.4062 11.4688 11.8125 12.0312L10.9375 11.1562C11.4167 10.6979 11.7969 10.1536 12.0781 9.52344C12.3594 8.89323 12.5 8.21875 12.5 7.5C12.5 6.10417 12.0156 4.92188 11.0469 3.95313C10.0781 2.98438 8.89583 2.5 7.5 2.5C6.10417 2.5 4.92188 2.98438 3.95313 3.95313C2.98438 4.92188 2.5 6.10417 2.5 7.5C2.5 8.21875 2.64062 8.89062 2.92188 9.51562C3.20312 10.1406 3.58854 10.6823 4.07812 11.1406L3.1875 12.0312ZM4.95312 10.2656C4.58854 9.92188 4.29688 9.51302 4.07812 9.03906C3.85938 8.5651 3.75 8.05208 3.75 7.5C3.75 6.45833 4.11458 5.57292 4.84375 4.84375C5.57292 4.11458 6.45833 3.75 7.5 3.75C8.54167 3.75 9.42708 4.11458 10.1562 4.84375C10.8854 5.57292 11.25 6.45833 11.25 7.5C11.25 8.05208 11.1406 8.56771 10.9219 9.04688C10.7031 9.52604 10.4115 9.93229 10.0469 10.2656L9.15625 9.375C9.41667 9.13542 9.6224 8.85417 9.77344 8.53125C9.92448 8.20833 10 7.86458 10 7.5C10 6.8125 9.75521 6.22396 9.26562 5.73438C8.77604 5.24479 8.1875 5 7.5 5C6.8125 5 6.22396 5.24479 5.73438 5.73438C5.24479 6.22396 5 6.8125 5 7.5C5 7.875 5.07552 8.22135 5.22656 8.53906C5.3776 8.85677 5.58333 9.13542 5.84375 9.375L4.95312 10.2656Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcasts);
export default __webpack_public_path__ + "static/media/podcasts.1703c8d35b7593a995385876125121f3.svg";
export { ForwardRef as ReactComponent };